export default __webpack_public_path__ + "static/media/ya.a22cf41a.jpg";